import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';
import { Directive } from '@angular/core';
@Directive({
    selector:'[trim]',
    providers:[{
        provide:NG_VALIDATORS,
        useExisting:TrimValidator ,
        multi:true
    }]
})
export class TrimValidator implements Validator{
    validate(control: AbstractControl):{[key:string]:boolean}|null{

        const isWhitespace = (control.value || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { 'whitespace': true };
            
     }



}